import React from 'react';
import { createRoot } from 'react-dom/client';
import MainViewMobile from "./searchMobile/MainView";
import MainViewDesktop from "./searchDesktop/MainView";
import MainViewTablet from "./searchTablet/MainView";

let rootMobile = null;
let rootDesktop = null;
let rootTablet = null;

let currentSize = null;

function renderBasedOnScreenSize() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 480 && currentSize !== 'mobile') {
        const containerMobile = document.getElementById('container-search-mobile');
        if (containerMobile) {
            if (!rootMobile) {
                rootMobile = createRoot(containerMobile);
            }
            rootMobile.render(<MainViewMobile />);
            currentSize = 'mobile';
        }
    } else if (screenWidth >= 480 && screenWidth < 1200 && currentSize !== 'tablet') {
        const containerTablet = document.getElementById('mobile-menu-search');
        if (containerTablet) {
            if (!rootTablet) {
                rootTablet = createRoot(containerTablet);
            }
            rootTablet.render(<MainViewTablet />);
            currentSize = 'tablet';
        }
    } else if (screenWidth >= 1200 && currentSize !== 'desktop') {
        const containerDesktop = document.getElementById('search-product-desktop');
        if (containerDesktop) {
            if (!rootDesktop) {
                rootDesktop = createRoot(containerDesktop);
            }
            rootDesktop.render(<MainViewDesktop />);
            currentSize = 'desktop';
        }
    }
}

renderBasedOnScreenSize();

window.addEventListener('resize', renderBasedOnScreenSize);